/* TNLVZN storefront enhancements. Product and checkout requests remain native Shopify forms. */
(() => {
  let headerObserver;
  const syncHeaderOffset = () => {
    const header = document.querySelector('.tv-header-section');
    if (!header) return;
    const update = () => {
      const height = Math.ceil(header.getBoundingClientRect().height);
      if (height) document.documentElement.style.setProperty('--tv-header-height', `${height}px`);
    };
    update();
    headerObserver?.disconnect();
    if ('ResizeObserver' in window) {
      headerObserver = new ResizeObserver(update);
      headerObserver.observe(header);
    }
  };
  const initialize = (root = document) => {
    syncHeaderOffset();
    document.querySelectorAll('[data-tv-external-offer]').forEach(button => {
      button.hidden = !document.querySelector('[data-tv-welcome]');
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        button.focus({ preventScroll: true });
        document.querySelector('[data-tv-welcome-open]')?.click();
      });
    });
    root.querySelectorAll('[data-tv-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const thumbs = [...gallery.querySelectorAll('[data-tv-thumb]')];
      const slides = [...gallery.querySelectorAll('[data-tv-slide]')];
      thumbs.forEach(button => button.addEventListener('click', () => {
        const index = Number(button.dataset.tvThumb);
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
        slides.forEach((slide, i) => slide.hidden = i !== index);
        const counter = gallery.querySelector('[data-tv-gallery-count]');
        if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      }));
    });
    root.querySelectorAll('[data-tv-quantity]').forEach(control => {
      if (control.dataset.ready) return;
      control.dataset.ready = 'true';
      const input = control.querySelector('input');
      const clamp = value => Math.max(Number(input.min) || 1, Math.min(Number(input.max) || 999, value));
      control.querySelectorAll('[data-tv-step]').forEach(button => button.addEventListener('click', () => {
        input.value = clamp((Number(input.value) || 1) + Number(button.dataset.tvStep));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      input.addEventListener('change', () => { input.value = clamp(Math.floor(Number(input.value) || 1)); });
    });
    root.querySelectorAll('[data-tv-variants]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const price = select.closest('.tv-product-info').querySelector('.tv-price');
        if (price) price.textContent = select.selectedOptions[0].dataset.price;
      });
    });
    root.querySelectorAll('.tv-mobile-menu a').forEach(link => {
      if (link.dataset.tvMenuReady) return;
      link.dataset.tvMenuReady = 'true';
      link.addEventListener('click', () => link.closest('.tv-mobile-menu').removeAttribute('open'));
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('[data-tv-welcome]')) {
      document.querySelectorAll('[data-tv-external-offer]').forEach(button => { button.hidden = true; });
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.tv-mobile-menu[open]');
    if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
    document.querySelectorAll('.tv-desktop-nav .tv-nav-submenu[open]').forEach(submenu => { submenu.removeAttribute('open'); submenu.querySelector('summary').focus(); });
  });
})();
